export const predefinedPayloads: Record<string, string> = {
  'Example Message': 'Example Message',
  'Hello World': 'Hello World',
};
